import $ from 'jquery'
import { trackGtmEvent } from '../../util/tracking'

$(document).on('click', 'a.dhsv_vc_cta_medium', function () {
  var trackingtype = $(this).data('tracking')
  trackGtmEvent('ctaInteraction', {
    ctaInteraction: 'cta',
    ctaType: trackingtype,
  })
})

$(document).on('click', '.dhsv_vc_cta_large a', function () {
  var trackingtype = $(this).data('tracking')
  trackGtmEvent('ctaInteraction', {
    ctaInteraction: 'cta',
    ctaType: trackingtype,
  })
})

$(document).on('click', 'a.dhsv_vc_cta_small', function () {
  var trackingtype = $(this).data('tracking')
  trackGtmEvent('ctaInteraction', {
    ctaInteraction: 'cta',
    ctaType: trackingtype,
  })
})

$(document).on('click', '.dhsv-custom-topbar-link a', function () {
  var trackingtype = $(this).data('tracking')
  trackGtmEvent('ctaInteraction', {
    ctaInteraction: 'cta',
    ctaType: trackingtype,
  })
})
